<template>
  <section class="saved-scenario-alert alert alert-info">
    <strong>Saved scenario:</strong> {{ title }}
  </section>
</template>

<script>
export default {
  name: 'saved-scenario-alert',
  props: ['title'],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utilities/saved-scenario-alert.vue